/**
 * Role predicates shared by the router guard and the views that route on the
 * same rule.
 *
 * These live outside `router.ts` on purpose: importing that module constructs
 * the router (and its history) as a side effect, which breaks any unit test
 * that only needs the predicate. Keeping one definition here means a view and
 * the guard that backs it cannot drift apart.
 */

/** Only the `proctor` role must present a TOTP second factor. */
export function requiresProctorMfa(role: string | null | undefined): boolean {
  return role === 'proctor'
}
